import 'whatwg-fetch'
import { Toast } from 'antd-mobile';
import {href} from './util'

// function hackMessage(msg) {
//   if (msg) {
//     if (msg === 'authorityFailure' || msg === '没有登录！') {
//       href('/login');
//     } else if (msg === 'Read timed out') {
//       Toast.fail('请求超时！',1)
//     } else if(msg !== 'openid获取登录失败'){
//       Toast.fail(msg,1)
//     }
//   }
// }

function checkStatus(response) {
  if (response.status >= 200 && (response.status < 300 || response.status === 401)) {
    return response
  }
  Toast.fail(`请求错误 ${response.status}: ${response.url}`,1);
  const error = new Error(response.statusText)
  error.response = response
  throw error
}

function serialize(obj = {}) {
  return Object.keys(obj)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join('&')
}

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 * @param {string} preventXXSKey 通过防注入的字段
 */
export const post  = function(options) {
  const defaultOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    credentials: 'include',
  }
  
  function isString(str){ 
    return (typeof str=='string')&&str.constructor==String; 
  } 

  const { url, data, ...opts } = options
  let newOptions = { ...defaultOptions, ...opts }
  // data.openid = cookies.get('openid');
  if(options.headers && options.headers['Content-Type'] && options.headers['Content-Type'].indexOf('multipart/form-data') >= 0) {
    let newData = new FormData(), key;
    for(key in data) {
      if(key != 'file'){
        newData.append(key, data[key]);
      }
    }
    // console.log(data)
    for (var i = 0; i < data.file.length; i++){
      newData.append('file',data.file[i]);
    }
    newOptions.body = newData;
    delete newOptions.headers;
  }
  else if(options.headers && options.headers['Content-Type'] && options.headers['Content-Type'].indexOf('application/json') >= 0) {
    newOptions.body = JSON.stringify(data)
  }
  else {
    let key;
    for(key in data) {
      if(data[key] && isString(data[key]) && data[key].length>0){
        const ele = document.createElement('span');
        ele.appendChild(document.createTextNode(data[key]));
        data[key] = ele.innerHTML;
      }
    }
    newOptions.body = serialize(data)
  }
  
  
  return fetch(url, newOptions)
    .then(checkStatus)
    .then(response => response.json())
    .then(json => {
      // if(json.result !== 'success') {
      //   hackMessage(json.msg);
      // }
      let key,data = json.data;
      if(!isString(data)){
        let preventXXSKey = options.preventXXSKey ? options.preventXXSKey.split(',') : [];
        if(preventXXSKey.length > 0){
          for(key in data) {
            if(preventXXSKey.length > 0){
              for(var i =0;i<preventXXSKey.length; i++){
                if(key === preventXXSKey[i]){
                  console.log(key,preventXXSKey[i])
                  preventXXSKey.splice(i,1);
                  break;
                }else{
                  if(data[key] && isString(data[key]) && data[key].length>0 && i+1 === preventXXSKey.length){
                    const ele = document.createElement('span');
                    ele.innerHTML = data[key];
                    data[key] = ele.textContent;
                  }
                }                
              }
            }else{
              if(data[key] && isString(data[key]) && data[key].length>0){
                const ele = document.createElement('span');
                ele.innerHTML = data[key];
                data[key] = ele.textContent;
              }
            }
          }
        }else{
          for(key in data) {
            if(data[key] && isString(data[key]) && data[key].length>0){
              const ele = document.createElement('span');
              ele.innerHTML = data[key];
              data[key] = ele.textContent;
            }
          }
        }
      }
      json.data = data;
      return json; 
    })
    .catch(error => {
      if (error.code) {
        Toast.fail(error.message, 1);
      }
      if ('stack' in error && 'message' in error) {
        Toast.fail(error.message, 1);
      }
      return error
    })
}



// WEBPACK FOOTER //
// ./src/utils/request.js